<template>
  <div class="zoox-info-progress zoox-component">
    <div
      v-for="(_, tick) in maxTicks"
      :key="tick"
      :style="{backgroundColor: defineColor(tick + 1)}"
      class="rectangle"
    >
      <slot v-if="value === tick + 1" name="check">
        <v-tooltip v-if="$scopedSlots.tooltip" bottom>
          <template v-slot:activator="{on}">
            <z-icon class="icon" size="32" right color="#239465" v-on="on">
              {{ icon }}
            </z-icon>
          </template>
          <span>
            <!--@slot Slot que define o conteúdo do tooltip -->
            <slot name="tooltip"></slot>
          </span>
        </v-tooltip>
        <z-icon v-else class="icon" size="32" right color="#239465">
          {{ icon }}
        </z-icon>
      </slot>
    </div>
  </div>
</template>

<script>
const COLORS = [
  '#485FC0',
  '#3283BC',
  '#239BBA',
  '#18ADB8',
  '#1DA391',
  '#239465',
  '#2C8A4F',
  '#357A3F',
  '#3F6D2C',
  '#4F5A23',
  '#5F4118',
  '#6F2F13',
  '#7F1E0E',
  '#8F0D09',
]

/**
 * Componente utilizado para indicar estado de progresso.
 *
 * @displayName Info Progress
 */
export default {
  name: 'ZInfoProgress',
  props: {
    /**
     * Número de retângulos (Máximo = número de cores no array `colors`)
     */
    ticks: {
      type: Number,
      required: true,
    },
    /**
     * Permite escolher quantas barras estarão preenchidas por default
     */
    value: {
      type: Number,
      required: true,
    },
    /**
     * Permite escolher a cor dos retangulos.
     */
    colors: {
      type: Array,
      default: () => COLORS,
    },
    /**
     * Permite escolher qual ícone será mostrado no componente.
     */
    icon: {
      type: String,
      default: '$check_circle_outline_rounded',
    },
  },
  computed: {
    maxTicks() {
      return this.ticks >= this.colors.length ? this.colors.length : this.ticks
    },
  },
  methods: {
    defineColor(tick) {
      return this.value >= tick ? this.colors[tick - 1] : 'var(--black-100)'
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-info-progress {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  width: 488.45px;
  height: 14px;
  .rectangle {
    width: 66.35px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .icon {
    margin: 0;
    left: 13px;
    border-radius: 50%;
    background-color: var(--white);
  }
}
</style>
